import { render } from "./BaseProfilePhoto.vue?vue&type=template&id=42190d8e&scoped=true"
import script from "./BaseProfilePhoto.vue?vue&type=script&lang=js"
export * from "./BaseProfilePhoto.vue?vue&type=script&lang=js"

import "./BaseProfilePhoto.vue?vue&type=style&index=0&id=42190d8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42190d8e"]])

export default __exports__